module.exports = __webpack_public_path__ + "static/media/calendar.8d93dcb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/calendar.png
// module id = 1697
// module chunks = 0